import React from 'react'
import { connect } from 'react-redux'
// @ts-ignore no types
import { canUseDom } from '@adc/core-utils/src/helpers/environments'
import config from '@adc/configment'
import * as blueprint from '@adc/blueprint'
import type { primitives } from '@adc/blueprint'
import { useListingContext } from 'common/context/listing'
import {
  hooks,
  PhotoGallery as ListingPhotoGallery,
  useApplicationContext,
  constants,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { withModalHooks } from 'common/hooks/useModalFeatures'
import { getAlternativeItems } from './CustomChiclets'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)

interface PhotoGalleryProps {
  isPropertyReportAvailable: boolean
  pushOnboardingQueueItem: (args: any[]) => void
  toggleAuthModal: () => void
}

const PhotoGallery = ({
  isPropertyReportAvailable,
  toggleAuthModal,
  pushOnboardingQueueItem,
}: PhotoGalleryProps) => {
  const { listing } = useListingContext()
  const isSmartSale = blueprint.listing.utils.isSmartSale(listing)
  const { featureFlags, user: untypedUser } = useApplicationContext()
  const user = untypedUser as primitives.AuctionUser

  const isMounted = hooks.useIsMounted()
  const alternativeItems = getAlternativeItems({
    featureFlags,
    isPropertyReportAvailable,
    listing,
    pushOnboardingQueueItem,
    toggleAuthModal,
    user,
  })

  return canUseDom() && isMounted ? (
    <div
      className={cx('container')}
      id='photo-gallery'
      data-elm-id='photo-gallery'
    >
      <ListingPhotoGallery
        config={{
          GOOGLE_MAP_CHANNEL: config.get('GOOGLE_MAP_CHANNEL'),
          GOOGLE_MAP_CLIENT_ID: config.get('GOOGLE_MAP_CLIENT_ID'),
          LISTING_DEFAULT_PHOTO_URL: config.get(
            'LISTING_DEFAULT_PHOTO_URL',
            ''
          ),
        }}
        alternativeItems={alternativeItems as object[]}
        featureFlags={featureFlags}
        shouldShowRibbon
        fluid={false}
        listing={listing}
        showMultiple
        // @ts-ignore needed for validation, TODO to fix DS type
        watermarkType={
          isSmartSale ? constants.watermarkTypes.SmartSale : undefined
        }
        displayBanner={false}
      />
    </div>
  ) : null
}

const mapStateToProps = (store: any) => ({
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
})

export default connect(mapStateToProps)(withModalHooks(PhotoGallery))
